import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as actasService from '../../services/actas/actasService';
import {
  buildActaExamenMateriaDisplay,
  classifyActasError,
  formatActaExamenTipo,
  isActaExamenFechaActaEditable,
  isActaExamenResultadoCargado,
  toSaveActaExamenEncabezadoPayload,
  validateEncabezadoForm
} from '../../services/actas/actasDto';
import { displayDate, parseDate } from '../../services/dates/dateService';
import { ConfirmDialog } from '../common/ConfirmDialog';
import { CalendarDatePicker } from '../common/CalendarDatePicker';

export class UpdateEncabezado extends Component {
  static displayName = UpdateEncabezado.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      showErrorMessage: false,
      success: false,
      showSuccessDialog: false,
      id: this.props.match.params.id,
      errorMessage: '',
      folio: '',
      libro: '',
      materia: '',
      fechaExamen: '',
      fechaPromocion: null,
      tipoActa: '',
      actaCargada: false,
      fechaPromocionPendiente: false
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWActasExamen');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (validateEncabezadoForm(this.state.libro, this.state.folio, {
      tipoActa: this.state.tipoActa,
      fechaPromocion: this.state.fechaPromocion,
      actaCargada: this.state.actaCargada
    })) {
      this.setState({ showErrorMessage: false, errorMessage: '', fechaPromocionPendiente: false });
      this.postEncabezado();
      return;
    }
    const fechaActaEditable = isActaExamenFechaActaEditable(this.state.tipoActa) && this.state.actaCargada;
    this.setState({
      showErrorMessage: true,
      errorMessage: fechaActaEditable
        ? 'Debe ingresar el libro, el folio y la fecha del acta'
        : 'Debe ingresar el libro y el folio',
      fechaPromocionPendiente: fechaActaEditable && !this.state.fechaPromocion
    });
  };

  handleOnChangeFolio = (e) => {
    this.setState({ folio: e.target.value });
  };

  handleOnChangeLibro = (e) => {
    this.setState({ libro: e.target.value });
  };

  handleFechaPromocion = (fecha) => {
    this.setState({ fechaPromocion: fecha, fechaPromocionPendiente: false });
  };

  handleSuccessDialogClose = () => {
    this.setState({ showSuccessDialog: false, success: true });
  };

  renderMetadataField(label, value) {
    const display = String(value ?? '').trim();
    return (
      <div className="md-page__field md-page__field--inline-readonly">
        <span className="md-page__field-label">{label}</span>
        <div
          className="md-page__field-readonly md-page__field-readonly--single-line"
          title={display}
        >
          {display}
        </div>
      </div>
    );
  }

  renderEditableField(label, id, value, onChange) {
    return (
      <div className="md-page__field">
        <label className="md-page__field-label" htmlFor={id}>{label}</label>
        <input
          id={id}
          className="md-page__field-input"
          type="text"
          value={value}
          disabled={this.state.loading}
          onChange={onChange}
        />
      </div>
    );
  }

  renderFechaActaEncabezadoField(fechaActaEditable) {
    const fechaDisplay = displayDate(this.state.fechaExamen);

    return (
      <div className="md-page__field">
        <label
          className="md-page__field-label"
          htmlFor={fechaActaEditable ? 'update-encabezado-fecha-promocion' : undefined}
        >
          Fecha del acta
        </label>
        {fechaActaEditable ? (
          <CalendarDatePicker
            inputId="update-encabezado-fecha-promocion"
            className={`md-page__field-input${this.state.fechaPromocionPendiente ? ' md-page__field-input--invalid' : ''}`}
            selected={this.state.fechaPromocion}
            onChange={this.handleFechaPromocion}
            disabled={this.state.loading}
          />
        ) : (
          <div
            className="md-page__field-readonly md-page__field-readonly--single-line"
            title={fechaDisplay}
            aria-readonly="true"
          >
            {fechaDisplay}
          </div>
        )}
      </div>
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-aex" />;
    }

    const materiaDisplay = this.state.materia.trim();
    const fechaActaEditable = isActaExamenFechaActaEditable(this.state.tipoActa) && this.state.actaCargada;

    return (
      <div className="md-page md-update-encabezado-acta-examen">
        <Link className="md-page__back-link" to="/md-aex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 id="update-encabezado-acta-examen-title" className="md-page__title">
            Modificar encabezado de acta de examen
          </h1>
        </div>
        <p className="md-page__subtitle">
          {fechaActaEditable
            ? 'Actualice el libro, el folio y la fecha del acta seleccionada.'
            : 'Actualice el libro y el folio del acta seleccionada.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <div className="md-page__form-card md-update-encabezado-acta-examen__metadata-card">
          {this.renderMetadataField('Materia', materiaDisplay)}
          {this.renderMetadataField('Tipo de acta', formatActaExamenTipo(this.state.tipoActa))}
        </div>

        <div className="md-page__form-card md-update-encabezado-acta-examen__encabezado-card">
          <p className="md-page__form-section-title">Encabezado del acta</p>
          <div className="md-page__form-card--grid md-update-encabezado-acta-examen__encabezado-grid">
            {this.renderFechaActaEncabezadoField(fechaActaEditable)}
            {this.renderEditableField('Libro', 'acta-examen-libro', this.state.libro, this.handleOnChangeLibro)}
            {this.renderEditableField('Folio', 'acta-examen-folio', this.state.folio, this.handleOnChangeFolio)}
          </div>
        </div>

        <div className="md-update-encabezado-acta-examen__confirm-bar">
          <button
            type="button"
            className="md-page__form-btn md-page__form-btn--primary"
            onClick={this.handleConfirmButton}
            disabled={this.state.loading}
          >
            Confirmar
          </button>
        </div>

        <ConfirmDialog
          open={this.state.showSuccessDialog}
          title="Encabezado actualizado"
          message="El encabezado del acta se guardó correctamente."
          confirmLabel="Confirmar"
          showCancel={false}
          variant="primary"
          onConfirm={this.handleSuccessDialogClose}
          onCancel={this.handleSuccessDialogClose}
        />
      </div>
    );
  }

  handleActasError(error) {
    const outcome = classifyActasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false
    });
  }

  async populateData() {
    try {
      const returnModel = await actasService.getActaExamenDetalle(this.state.id);
      const first = returnModel[0];
      const actaCargada = isActaExamenResultadoCargado(first?.detalleActaResultado);
      this.setState({
        folio: first?.actaExamenFolio != null ? String(first.actaExamenFolio) : '',
        libro: first?.actaExamenLibro != null ? String(first.actaExamenLibro) : '',
        materia: buildActaExamenMateriaDisplay(first),
        fechaExamen: first?.mesaExamenFechaExamen ?? '',
        fechaPromocion: parseDate(first?.fechaActaPromocion || first?.mesaExamenFechaExamen),
        tipoActa: first?.actaExamenTipo ?? '',
        actaCargada,
        loading: false
      });
    } catch (error) {
      this.handleActasError(error);
    }
  }

  async postEncabezado() {
    this.setState({ loading: true });
    try {
      await actasService.saveActaExamenEncabezado(toSaveActaExamenEncabezadoPayload({
        folio: this.state.folio,
        libro: this.state.libro,
        actaId: this.state.id,
        tipoActa: this.state.tipoActa,
        fechaPromocion: this.state.fechaPromocion
      }));
      this.setState({ loading: false, showSuccessDialog: true });
    } catch (error) {
      this.handleActasError(error);
    }
  }
}
